import { UserIsOnlineMapI } from "../../lib/interfaces/chat";
import { ChatContactI } from "./types";

export const getChatContactOnlineStatus = (
  onlineStatusMap: UserIsOnlineMapI | undefined,
  contact: ChatContactI | undefined
) => {
  if (!contact || !onlineStatusMap) {
    return null;
  }

  return !(
    onlineStatusMap && onlineStatusMap[contact.id]?.isOnline === undefined
  );
};
